/**
 * Helper function for PostHog tracking outside of React components
 */

import PosthogService from './PosthogService';
import { PosthogEventProperties } from './types';

/**
 * Track a PostHog event from anywhere (sagas, thunks, utilities)
 * Simple wrapper to get instance and fire event
 */
export const trackPosthogEvent = (eventName: string, properties?: PosthogEventProperties): void => {
  try {
    const posthog = PosthogService.getInstance();
    posthog.track(eventName, properties);
  } catch (error) {
    console.error(`[PostHog] Error tracking event: ${eventName}`, error);
  }
};

/**
 * Track a page view from anywhere (sagas, thunks, utilities, components)
 * Simple wrapper to get instance and fire page view event
 */
export const trackPosthogPageView = (path: string, properties?: PosthogEventProperties): void => {
  try {
    const posthog = PosthogService.getInstance();
    posthog.trackPageView(path, properties);
  } catch (error) {
    console.error(`[PostHog] Error tracking page view: ${path}`, error);
  }
};